export default __webpack_public_path__ + "static/media/less-than-small.13a5454a.svg";